import { ACTIVITY_TYPE } from '../../const';
import PropTypes from 'prop-types';

export default class SearchElement {
  static propTypes = {
    classroomId: PropTypes.string,
    classroomName: PropTypes.string,
    bookId: PropTypes.string,
    bookName: PropTypes.string,
    unitId: PropTypes.string,
    lessonId: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.oneOf([ACTIVITY_TYPE.BOOK, ACTIVITY_TYPE.UNIT, ACTIVITY_TYPE.LESSON]),
    imageUrl: PropTypes.string,
    classroomImageUrl: PropTypes.string
  };

  primary;

  constructor(classroomId, classroomName, bookId, bookName, unitId, lessonId, name, type, imageUrl, classroomImageUrl) {
    this.classroomId = classroomId;
    this.classroomName = classroomName;
    this.bookId = bookId;
    this.bookName = bookName;
    this.unitId = unitId;
    this.lessonId = lessonId;
    this.name = name;
    this.type = type;
    this.imageUrl = imageUrl;
    this.classroomImageUrl = classroomImageUrl;
  }
}
